export var localstorage = function (key) {
    var get = function () {
        return JSON.parse(localStorage.getItem(key));
    };
    var set = function (item) {
        localStorage.setItem(key, JSON.stringify(item));
    };
    var clear = function () {
        localStorage.clear();
    };
    return { get: get, set: set, clear: clear };
};
